import { render, staticRenderFns } from "./portrait.vue?vue&type=template&id=7d6c16e8&scoped=true"
import script from "./portrait.vue?vue&type=script&lang=js"
export * from "./portrait.vue?vue&type=script&lang=js"
import style0 from "./portrait.vue?vue&type=style&index=0&id=7d6c16e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c16e8",
  null
  
)

export default component.exports